import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { signOutUserStart } from './../redux/User/user.actions';
import logo from './../../src/assets/CD Horizontal_whiteFont_opt.png';

import * as ROUTES from './../components/Routes';


const mapState = ({ user }) => ({
	currentUser: user.currentUser
})

const VendorDashLayout = props => {
  const dispatch = useDispatch();
  const [active, setActive] = useState(false);
  const { currentUser } = useSelector(mapState);

  const signOut = () => {
    dispatch(signOutUserStart());
  };

  const handleClick = () => {
    setActive(!active);
  };

  return (
    <div className="dashContainter verticalNav">


      {/* -- mobile menu bar -- */}
      <div className="dash">
        <nav className="container text-white">
          <div className="topMenu">
            <Link to={ROUTES.DASHBOARD}>
              <img className="head-logo" src={logo} alt="chore door logo"/>
            </Link>
            <div className="p-1">
              <button className="mobile-menu" onClick={handleClick}>
                <svg
                  className='svgIcon'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M4 6h16M4 12h16M4 18h16'
                  />
                </svg>
              </button>
            </div>
          </div>
        </nav>


        {/* sidebar */}
        <div className={`${active ? '' : 'mobSide'} text-white sideDash space-y-6 py-4 absolute inset-y-0 left-0  transform transition duration-200 ease-in-out z-10 menu`}>
          <div className="img pb-2">
              
              <span className="displayName">
                {currentUser.displayName}
              </span>
          </div>
          <nav className="">
          <ul>
              <li>
                <Link to={ROUTES.VENDOR_DASHBOARD}>
                  DASHBOARD
                </Link>
              </li>
              <li>
                <Link to={ROUTES.VENDOR_ACCT_DETAILS}>
                  ACCOUNT DETAILS
                </Link>
              </li>
              <li>
                
                <div className="dropdown">
                <span >
                  CUSTOMERS
                </span>
                  
                  <div className="dropdown-content">
                  <Link to={ROUTES.VENDOR_CONVERSATIONS}>
                    CONVERSATIONS
                  </Link>
                  <Link to={ROUTES.VENDOR_QUOTES}>
                    QUOTES
                  </Link>
                  <Link to={ROUTES.VENDOR_INVOICES}>
                    INVOICES
                  </Link>
                  <Link to={ROUTES.VENDOR_RECEIPTS}>
                    RECEIPTS
                  </Link>
                  </div>
                </div> 
              </li>
              <li>
                <Link to={ROUTES.VENDOR_MAPS}>
                  MAP
                </Link>
              </li>
              <li>
                <Link to={ROUTES.VENDOR_SERVICES}>
                  SERVICES
                </Link>
              </li>
              <li>
                <Link to={ROUTES.VENDOR_APPTS}>
                  APPOINTMENTS
                </Link>
              </li>
              <li>
                <Link to={ROUTES.VENDOR_CONTACT}>
                  CONTACT US
                </Link>
              </li>
              <li>
                <span className="signOut" onClick={() => signOut()}>
                  LOG OUT
                </span>
              </li>
            </ul>

              
          </nav>    
        </div>
      </div>

              {/* sidebar */}
      <div className={`text-white mainSideDash  menu`}>


        <div className="vertimgLogo pt-5 pb-3">
            <img className="head-logo px-2" src={logo} alt="chore door logo"/>
            <span className="displayName">
              {currentUser.displayName}
            </span>
        </div>
        <nav className="">
           
        <ul>
              <li>
                <Link to={ROUTES.VENDOR_DASHBOARD}>
                  DASHBOARD
                </Link>
              </li>
              <li>
                <Link to={ROUTES.VENDOR_ACCT_DETAILS}>
                  ACCOUNT DETAILS
                </Link>
              </li>
              <li>
                
                <div className="dropdown">
                <span >
                  CUSTOMERS
                </span>
                  
                  <div className="dropdown-content">
                  <Link to={ROUTES.VENDOR_CONVERSATIONS}>
                    CONVERSATIONS
                  </Link>
                  <Link to={ROUTES.VENDOR_QUOTES}>
                    QUOTES
                  </Link>
                  <Link to={ROUTES.VENDOR_INVOICES}>
                    INVOICES
                  </Link>
                  <Link to={ROUTES.VENDOR_RECEIPTS}>
                    RECEIPTS
                  </Link>
                  </div>
                </div> 
              </li>
              <li>
                <Link to={ROUTES.VENDOR_MAPS}>
                  MAP
                </Link>
              </li>
              <li>
                <Link to={ROUTES.VENDOR_SERVICES}>
                  SERVICES
                </Link>
              </li>
              <li>
                <Link to={ROUTES.VENDOR_APPTS}>
                  APPOINTMENTS
                </Link>
              </li>
              <li>
                <Link to={ROUTES.VENDOR_CONTACT}>
                  CONTACT US
                </Link>
              </li>
              <li>
                <span className="signOut" onClick={() => signOut()}>
                  LOG OUT
                </span>
              </li>
            </ul>
          

        </nav>    
    </div>






    
      {/* -- Content -- */}
      <div className="content">
          {props.children}
      </div>
    </div>
  );
};

export default VendorDashLayout;










// import React from 'react';
// import { Link } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import { signOutUserStart } from './../redux/User/user.actions';

// import VerticalNav from './../components/VerticalNav';
// import * as ROUTES from './../components/Routes';

// const VendorDashLayout = props => {
//   const dispatch = useDispatch();

//   const signOut = () => {
//     dispatch(signOutUserStart());
//   };

//   return (
//     <div className="dashboardLayout">
//       <div className="controlPanel">
//         <div className="sidebar">
//           <VerticalNav>
            // <ul>
            //   <li>
            //     <Link to={ROUTES.VENDOR_DASHBOARD}>
            //       DASHBOARD
            //     </Link>
            //   </li>
            //   <li>
            //     <Link to={ROUTES.VENDOR_ACCT_DETAILS}>
            //       ACCOUNT DETAILS
            //     </Link>
            //   </li>
            //   <li>
                
            //     <div className="dropdown">
            //     <Link >
            //       CUSTOMERS
            //     </Link>
                  
            //       <div className="dropdown-content">
            //       <Link to={ROUTES.VENDOR_CONVERSATIONS}>
            //         CONVERSATIONS
            //       </Link>
            //       <Link to={ROUTES.VENDOR_QUOTES}>
            //         QUOTES
            //       </Link>
            //       <Link to={ROUTES.VENDOR_INVOICES}>
            //         INVOICES
            //       </Link>
            //       <Link to={ROUTES.VENDOR_RECEIPTS}>
            //         RECEIPTS
            //       </Link>
            //       </div>
            //     </div> 
            //   </li>
            //   <li>
            //     <Link to={ROUTES.VENDOR_MAPS}>
            //       MAP
            //     </Link>
            //   </li>
            //   <li>
            //     <Link to={ROUTES.VENDOR_SERVICES}>
            //       SERVICES
            //     </Link>
            //   </li>
            //   <li>
            //     <Link to={ROUTES.VENDOR_APPTS}>
            //       APPOINTMENTS
            //     </Link>
            //   </li>
            //   <li>
            //     <Link to={ROUTES.VENDOR_CONTACT}>
            //       CONTACT US
            //     </Link>
            //   </li>
            //   <li>
            //     <span className="signOut" onClick={() => signOut()}>
            //       LOG OUT
            //     </span>
            //   </li>
            // </ul>
//           </VerticalNav>
//         </div>
//         <div className="content">
//           {props.children}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VendorDashLayout;



